// @flow
import React, { Fragment } from 'react';
import moment from 'moment';

import { t, has } from 'Src/i18n';

import { themes } from 'Components/widgets/trip-date-picker/TripDatePicker.themes';
import { type PriceOfDay } from 'Store/calendar/calendar.helper';

const COMPACT_MAX_CHARACTERS = 5;

export const DayWithPrice = ({
  day,
  price: { availability, price },
  shouldDisplayPrice,
  theme,
}: {
  day: Date,
  price: PriceOfDay,
  shouldDisplayPrice: boolean,
  theme: string,
}) => {
  const statusMessageKey = `booking.priceCalendar.priceStatus.${availability}`;
  const { thDayNumber, thDayPrice, thStatusMessage, thFrom } = themes[theme];

  const getCompactPrice = rawPrice => {
    const compactPrice = rawPrice?.replace(/[\s|.,]/gi, '') || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : '';
  };

  return (
    <Fragment>
      <span className={thDayNumber}>{moment(day).format('D')}</span>
      {has(statusMessageKey) && <span className={thStatusMessage}>{t(statusMessageKey)}</span>}
      {shouldDisplayPrice && (
        <Fragment>
          <span className={thFrom}>{t('price.format.from')}</span>
          <span data-testid="price" className={thDayPrice}>
            {theme === 'compact' ? getCompactPrice(price) : price}
          </span>
        </Fragment>
      )}
    </Fragment>
  );
};
